module.exports = "img/info.56673bb.png";